import React from 'react';
import './style.css';
import OnboardButton from '../../base/onboard-button-component/OnboardButton';
import { acceptRights } from '../../../api/ifec-verify-services/IfecVerifyService';

const AgreementPopup = (props) => {

    const { visible, setVisible, rightPanelLang = 'tr' } = props;
    return <>
        {
            visible && (
                <>
                    <div className="onboard-agreement-popup-opacity"></div>
                    <div className="onboard-agreement-popup-root">
                        <div className="onboard-agreement-popup-header">
                            <p>{rightPanelLang === 'tr' ? 'ÖNEMLİ HATIRLATMALAR' : 'IMPORTANT REMINDERS'}</p>
                            <span>{rightPanelLang === 'tr'
                                ? 'Devam etmeden önce aşağıdaki maddeleri inceleyin.'
                                : 'Please review the points below before continuing.'}</span>
                        </div>
                        <div className="onboard-agreement-popup-content">
                            <span>
                                {/*Dikkat edilmesi gereken maddeler;*/}
                                <ul>
                                    {rightPanelLang === 'tr' && (
                                        <>
                                            <li>Doğrulama hataları, <b>çoğunlukla yolcu bilgilerinin hatalı girilmesi
                                                sebebiyle</b> yaşanır.
                                            </li>
                                            <li>İnternet hızı yavaşsa, yolcu cihazında <b>VPN uygulamalarının
                                                kapatılması</b> önerilir.
                                            </li>
                                            <li>Gate to Gate özelliği <b>meydan bazlı farklılık göstermekte olup</b> hat
                                                bilgi formunda bilgisi yer alır. (Tüm yurt içi meydanlarda Gate to Gate
                                                aktiftir.)
                                            </li>
                                            <li><b>Ücretsiz WIFI kartları tek kullanımlıktır</b> ve giriş hataları
                                                genellikle <b>kodun yanlış girilmesinden</b> kaynaklanır.
                                            </li>
                                            <li><b>Sefer TK bilgisinin değişmediği aktarmalı uçuşlarda</b>, yolcularımız
                                                satın aldığı/aktif ettiği internet paketini devam uçuşunda kullanabilir.
                                                (Örneğin; TK215 IST-GRU-SCL)
                                            </li>
                                            <li><b>Yolcunun uçak değiştirdiği aktarmalı uçuşlarda</b>, ilk uçuşta satın
                                                alınan internet paketi devam uçuşunda kullanılamaz.
                                            </li>
                                            <li><b>Türk Telekom internet sistemli uçaklarda</b>, internet satın
                                                alımlarında <b>kredi kartı yanı sıra debit kart da
                                                    kullanılabilir.</b> (Anuvu’da kullanılamaz.)
                                            </li>
                                            <li>İnternete erişimin mümkün olabilmesi için mobil verinin kapalı olması
                                                gerekir.
                                            </li>
                                            <li>Koltuk veya bilet numarası ile giriş yapınca, M&S haklarına ulaşamayan
                                                yolcularımıza, M&S bilgileri ile giriş seçeneğinin kullanılması tavsiye
                                                edilir.
                                            </li>
                                        </>
                                    )}
                                    {rightPanelLang === 'en' && (
                                        <>
                                            <li>Verification errors usually occur <b>because passenger details are
                                                entered incorrectly</b>.
                                            </li>
                                            <li>If internet speed is low, advise passengers to <b>turn off VPN
                                                applications</b>.
                                            </li>
                                            <li>The Gate to Gate feature <b>varies by airport</b> and is shown in the
                                                line information form. (It is active at all domestic airports.)
                                            </li>
                                            <li><b>Free Wi-Fi cards are single-use</b>, and login errors are usually
                                                caused by <b>entering the code incorrectly</b>.
                                            </li>
                                            <li>On connecting flights <b>where the TK flight number does not change</b>,
                                                passengers can continue to use their purchased/activated package on the
                                                next segment. (Example: TK215 IST-GRU-SCL)
                                            </li>
                                            <li>On connecting flights <b>where the passenger changes aircraft</b>, the
                                                package bought on the first flight cannot be used on the next segment.
                                            </li>
                                            <li>On aircraft with the <b>Türk Telekom internet system</b>, <b>debit cards
                                                can also be used in addition to credit cards</b>. (Not available on
                                                Anuvu.)
                                            </li>
                                            <li>Mobile data must be turned off for internet access to work properly.
                                            </li>
                                            <li>If passengers cannot access M&S rights after seat/ticket login,
                                                recommend using the M&S login option.
                                            </li>
                                        </>
                                    )}
                                </ul>
                            </span>
                            <div className="onboard-agreement-popup-select-bar">
                                <OnboardButton
                                    label={rightPanelLang === 'tr' ? 'Okudum ve anladım.' : 'I have read and understood.'}
                                    onClick={() => {
                                        acceptRights();
                                        setVisible(false);
                                        localStorage.setItem('acceptRights', true);
                                    }} />
                            </div>
                        </div>
                    </div>
                </>
            )
        }
    </>;
};

export default AgreementPopup;
